import React from 'react';

export function LandingHero() {
  return (
    <section className="hero content-width" data-figma-node="125:49530" aria-labelledby="hero-title">
      <div className="hero__left">
        <div className="hero__primary">
          <h1 className="hero__title hero__title--wide" id="hero-title">Доверьте<br />перевозку тем,<br />кому <em>уже<br />доверяют</em></h1>
          <h1 className="hero__title hero__title--road"><span>Доверьте</span> <span>перевозку</span> <span>тем, кому <em>уже</em></span> <span><em>доверяют</em></span></h1>
          <form
            className="hero-form js-route-form"
            onSubmit={(e) => {
              e.preventDefault();
              window.location.hash = '#new-request-step-1';
            }}
          >
            <label className="route-field">
              <img src="/assets/figma/input-pin-default.svg" alt="" />
              <span><b>Откуда</b><input name="from" placeholder="Москва" aria-label="Откуда" /></span>
            </label>
            <label className="route-field">
              <img src="/assets/figma/input-pin-default.svg" alt="" />
              <span><b>Куда</b><input name="to" placeholder="Берлин" aria-label="Куда" /></span>
            </label>
            <button className="button button--hero" type="submit"><span className="button__label">Найти перевозчика</span><img className="button__icon" src="/assets/figma/button-arrow-up-right-white.svg" alt="" /></button>
          </form>
        </div>
        <a className="social-proof" href="#reviews">
          <span className="social-proof__avatars">
            <img src="/assets/landing/hero-avatar-1.webp" alt="" />
            <img src="/assets/landing/hero-avatar-2.webp" alt="" />
            <img src="/assets/landing/hero-avatar-3.webp" alt="" />
          </span>
          <span>1,254 довольных клиента</span><img className="social-proof__arrow" src="/assets/figma/button-arrow-up-right-brown.svg" alt="" />
        </a>
      </div>
      <img className="hero__image" src="/assets/landing/hero-dog.webp" alt="Золотистый ретривер едет в автомобиле" />
    </section>
  );
}
